import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_NEW_ROLE_LIST,
  SET_NEW_ROLE_PAGE_STATUS,
  // SET_NEW_ROLE_CONFIG_MODAL_DATA,
  SET_ADD_USER_CONFIG_MODAL_DATA,
  GET_USER_LIST,
  GET_ROLE_PERMIT,
  SET_NEW_ROLE_SEARCHDATA,
  SET_NEW_ROLE,
} = SYSTEMSETTING;

const initialState = {
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  permitData: [],
  userList: {
    data: [],
    total: 0,
  },
  searchData: {
    name: '',
  },
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  addUserData: {}, // 配置添加用户弹框的数据
  newRoleData: {}, // 配置添加角色弹框的数据
};

const newRole = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_NEW_ROLE_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_NEW_ROLE_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${GET_ROLE_PERMIT}_SUCCESS`:
      return {
        ...state,
        permitData:
          (action.payload.data && action.payload.data.permitTree) || [],
      };
    case `${GET_USER_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${SET_NEW_ROLE_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${SET_NEW_ROLE_SEARCHDATA}`:
      return {
        ...state,
        searchData: {...state.searchData, ...action.data},
      };
    case `${SET_NEW_ROLE}_SUCCESS`:
      return {
        ...state,
        newRoleData: action.payload.data || {},
      };
    case `${SET_ADD_USER_CONFIG_MODAL_DATA}`:
      return {
        ...state,
        addUserData: action.data,
      };
    default:
      return state;
  }
};

export default newRole;
